import React, { useState, useRef } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const DaterangePicker = ({ 
  selectionRange, 
  setSelectionRange, 
  style,
  renderInput // Add this prop
}) => {
  const [open, setOpen] = useState(false);
  const pickerRef = useRef(null);

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    let adjustedEnd = endDate ? new Date(endDate) : null;
    if (adjustedEnd) adjustedEnd.setHours(23, 59, 59, 999);

    setSelectionRange({
      ...selectionRange,
      startDate,
      endDate: adjustedEnd || startDate,
    });

    if (
      startDate &&
      endDate &&
      (startDate.getTime() !== endDate.getTime() || ranges.selection.label)
    ) {
      setOpen(false);
    }
  };

  // Default input if no custom render provided
  const defaultInput = (
    <input
      type="text"
      readOnly
      value={`${selectionRange.startDate.toLocaleDateString()} - ${selectionRange.endDate.toLocaleDateString()}`}
      onClick={() => setOpen(!open)}
      style={{
        padding: "8px",
        width: "250px",
        cursor: "pointer",
        backgroundColor: "#d4dfed",
        border: "2px solid #ccc",
        borderRadius: "8px",
      }}
    />
  );

  return (
    <div
      ref={pickerRef}
      style={{ position: "relative", display: "inline-block" }}
    >
      {/* Use custom renderInput or fallback to default */}
      {renderInput ? (
        renderInput({ 
          open, 
          setOpen, 
          selectionRange, 
          onClick: () => setOpen(!open) 
        })
      ) : (
        defaultInput
      )}

      {open && (
        <div
          className="shadow-lg border-2"
          style={{ position: "absolute", zIndex: 10, right: style }}
        >
          <DateRangePicker
            inputRanges={[]}
            ranges={[selectionRange]}
            onChange={handleSelect}
          />
        </div>
      )}
    </div>
  );
};

export default DaterangePicker;